/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductGroupDto } from '../../models/backend-product-group-dto';
import { BackendProductGroupRequestDto } from '../../models/backend-product-group-request-dto';

export interface SalesGroupsCreate$FormData$Params {
  body: BackendProductGroupRequestDto;
}

export function salesGroupsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesGroupsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductGroupDto>> {
  const rb = new RequestBuilder(rootUrl, salesGroupsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductGroupDto>;
    }),
  );
}

salesGroupsCreate$FormData.PATH = '/api/sales/groups/';
